// src/components/Testimonials.js
import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: "Carla M.",
    city: "Caracas",
    text: "¡Encontré un iPhone 15 por $150 menos que en cualquier tienda! Gracias a Quadramelo, ahorré tiempo y dinero.",
    avatar: ""
  },
  {
    name: "Javier R.",
    city: "Caracas",
    text: "No tenía idea de cómo comparar precios en línea. Un buscador de Quadramelo me consiguió una laptop gamer al mejor precio en 2 días.",
    avatar: ""
  },
  {
    name: "Lucía P.",
    city: "Caracas",
    text: "Compré mis audífonos Bose por la mitad del precio. El servicio fue rápido, honesto y súper profesional. ¡100% recomendado!",
    avatar: ""
  }
];

const Testimonials = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.sectionTitle}>Lo que dicen nuestros usuarios</h2>
        <div style={styles.grid}>
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              style={styles.card}
            >
              <motion.div
                whileHover={{ scale: 1.1, rotate: 5 }}
                style={styles.avatar}
              >
                {t.avatar}
              </motion.div>
              <p style={styles.testimonialText}>"{t.text}"</p>
              <p style={styles.author}>
                <strong>{t.name}</strong>, {t.city}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '5rem 1rem',
    backgroundColor: '#f8f9fa',
  },
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2.2rem',
    color: '#212529',
    marginBottom: '3rem',
    fontWeight: '700',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '2rem',
  },
  card: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
    border: '1px solid #e9ecef',
    transition: 'transform 0.3s ease',
  },
  avatar: {
    fontSize: '2.5rem',
    marginBottom: '1.2rem',
    textAlign: 'center',
    color: '#4361ee'
  },
  testimonialText: {
    fontSize: '1.05rem',
    color: '#495057',
    lineHeight: 1.7,
    fontStyle: 'italic',
    marginBottom: '1.2rem',
  },
  author: {
    fontSize: '1rem',
    color: '#6c757d',
    textAlign: 'right',
    fontWeight: '600',
  }
};

export default Testimonials;